import React, { useContext } from 'react';
import { useAuth } from '@jutro/auth';
import { Loader } from '@jutro/components';

import { SecureRoute } from '@jutro/router';

/**
 * Wraps a component in a secure route with an authentication context.
 *
 * @alias privateRouteWithAuthContext
 * @memberof module:digital-auth-react
 *
 * @param {ReactElement} WrappedComponent a component to be wrapped.
 *
 * @returns {ReactElement} the element wrapped in secure route with authentication context.
 */

const privateRouteWithAuthContext = (WrappedComponent) => {
    return function ContextComponent(...otherProps) {
        const auth = useAuth();
        const { accessToken, isAuthenticated, isPending } = auth;
        const authHeader = {'Authorization': `Bearer ${accessToken}`};

        return (
            <SecureRoute
                {...otherProps}
                render={(props) =>
                    // eslint-disable-next-line no-nested-ternary
                    !isPending ? (
                        isAuthenticated ? (
                            <WrappedComponent {...props} auth={auth} authHeader={authHeader} />
                        ) : null
                    ) : (
                        <Loader />
                    )
                }
            />
        );
    };
};

export default privateRouteWithAuthContext;
